import { useState } from "react";
import "./Waitlist.css";
import Modal from "../Modal/Modal";

const Waitlist = ({
  eyebrow,
  title,
  description,
  buttonText,
  showProgress = true,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="waitlist-section">
        <div className="waitlist-section__content">

          <span className="waitlist-section__eyebrow">
            {eyebrow}
          </span>

          <h2>{title}</h2>

          <p className="waitlist-section__description">
            {description}
          </p>

          <button
            type="button"
            className="waitlist-section__button"
            onClick={() => setIsModalOpen(true)}
          >
            <span>{buttonText}</span>
            <span className="waitlist-section__arrow">→</span>
          </button>

          {showProgress && (
            <div className="waitlist-section__progress">
              <p>Setup takes less than 15 minutes</p>

              <div className="waitlist-section__progress-bar">
                <span></span>
              </div>
            </div>
          )}

        </div>
      </section>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Waitlist;